import BirthdayCalendarOptionState from './schema/BirthdayCalendarOptionState';
import { createStore } from 'satcheljs';

/**
 * Creates store which reflects the current state of settings under birthday calendar option
 */
export default createStore<BirthdayCalendarOptionState>('birthdayCalendarOption', {
    birthdayCalendarEnabledInitial: null,
    birthdayCalendarEnabledCurrent: null,
});
